module.exports = __webpack_public_path__ + "img/iseatu-1024.b2b05a25.png";